/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plus_Membership_CnaInputs */

const en_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership`)
};

const ar_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership`)
};

const de_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership`)
};

const es_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership`)
};

const fr_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership`)
};

const it_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership`)
};

const ja_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership`)
};

const ko_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership`)
};

const pt_br_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership`)
};

const ru_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership`)
};

const th_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership`)
};

const tr_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership`)
};

const zh_cn_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员`)
};

const zh_tw_plus_membership_cna = /** @type {(inputs: Plus_Membership_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员`)
};

/**
* | output |
* | --- |
* | "Plus Membership" |
*
* @param {Plus_Membership_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plus_membership_cna = /** @type {((inputs?: Plus_Membership_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plus_Membership_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plus_membership_cna(inputs)
	if (locale === "ar") return ar_plus_membership_cna(inputs)
	if (locale === "de") return de_plus_membership_cna(inputs)
	if (locale === "es") return es_plus_membership_cna(inputs)
	if (locale === "fr") return fr_plus_membership_cna(inputs)
	if (locale === "it") return it_plus_membership_cna(inputs)
	if (locale === "ja") return ja_plus_membership_cna(inputs)
	if (locale === "ko") return ko_plus_membership_cna(inputs)
	if (locale === "pt_br") return pt_br_plus_membership_cna(inputs)
	if (locale === "ru") return ru_plus_membership_cna(inputs)
	if (locale === "th") return th_plus_membership_cna(inputs)
	if (locale === "tr") return tr_plus_membership_cna(inputs)
	if (locale === "zh_cn") return zh_cn_plus_membership_cna(inputs)
	return zh_tw_plus_membership_cna(inputs)
});